const AVERAGE_COLUMN_LIST_DATA = [
  "지종",
  "기준평량",
  "호기",
  "평균실평량",
  "수분\n[%]",
  "밀도\n[g/㎠]", 
  "MD 압강\n[kgf]",
  "CD 압강\n[kgf]",
  "CD Index\n[kgf/g/㎡]",
  "MD/CD",
  "파강\n[kgf]",
  "파강 Index\n[kgf/g/㎡]",
  "색상 L",
  "색상 A",
  "색상 B",
  "Cobb size\n[g/㎡]",
]

export default AVERAGE_COLUMN_LIST_DATA